import { environment } from '../src/environments/environment';
export const config=
{
  "aws_project_region": "us-east-1",
  "aws_cognito_region": "us-east-1",
  "aws_user_pools_id": "us-east-1_2AseFMapm",
  "aws_user_pools_web_client_id": environment.client_id,
  "oauth": {
    "domain": environment.domain,
    "scope": ["email", "openid"],
    "redirectSignIn": environment.redirectSignIn,
    "redirectSignOut": environment.redirectSignOut,
    "responseType": "code",
    "autoRedirect": true
  },
  "aws_cognito_username_attributes": [
    "EMAIL"
  ],
  "aws_cognito_social_providers": environment.aws_cognito_social_providers,
  "aws_cognito_signup_attributes": [
    "EMAIL"
  ],
  "aws_cognito_mfa_configuration": "OFF",
  "aws_cognito_mfa_types": [],
  "aws_cognito_password_protection_settings": {
    "passwordPolicyMinLength": 8,
    "passwordPolicyCharacters": [
      "REQUIRES_LOWERCASE",
      "REQUIRES_UPPERCASE",
      "REQUIRES_NUMBERS",
      "REQUIRES_SYMBOLS"
    ]
  },
  "aws_cognito_verification_mechanisms": [
    "EMAIL"
  ]
}
